import React, { useState } from 'react';
import { FieldErrors, SetFieldValue, UseFormRegister } from 'react-hook-form';

interface PaswordInputProps {
	register: UseFormRegister<any>;
	label: string,
	name: string,
	setValue: SetFieldValue<any>;
	isRequired: boolean,
	minLength?: number,
	maxLength?: number,
	errors: FieldErrors; // Generalized type to handle multiple field errors
	handleSteps: (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => void;
}

const PasswordInput: React.FC<PaswordInputProps> = ({ register, errors, handleSteps, label, name, setValue, isRequired, minLength= null, maxLength= null }) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	return (
		<div>
			<label className="block text-sm font-light mb-2">
				{label} {isRequired ? '*' : ""}
			</label>
			<div className='flex flex-row w-full relative'>
			<input
				type={showPassword ? "text" : "password"}
				{...register(name, {
					required: isRequired,
					minLength: minLength,
					maxLength: maxLength
				})}
				className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
				placeholder="Password"
				onChange={(e) => {
					handleSteps(e, name),
					setValue(name, e.target.value)
				}}
			/>
			<button
				type="button"
				className="absolute right-0 top-1/2 transform -translate-y-1/2 p-2"
				onClick={handleClickShowPassword}

			>
				{showPassword ? (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						className="w-6 h-6"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
						/>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
						/>
					</svg>

				) : (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						className="w-6 h-6"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
						/>
					</svg>

				)}
			</button>
			</div>
			{errors.Email?.type === 'required' && (
				<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">
					This is required
				</span>
			)}
			{errors.Password?.type === "minLength" && (
				<span role="alert" className="w-full text-red-500 bg-white text-xs my-1 pl-2">Min length expected</span>
			)}
			{errors.Password?.type === "maxLength" && (
				<span role="alert" className="w-full text-red-500 bg-white text-xs my-1 pl-2">Max length exceeded</span>
			)}
		</div>
	);
};

export default PasswordInput;
